<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
    style="z-index: 222"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-end" style="height: 10%;">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
          style="height: 10%;"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item @click.stop="switchLanguage">
              <p style="font-weight: bold; margin-top: 4px">{{ language }}</p>
            </md-list-item>
            <md-list-item
              class="md-list-item-content"
              v-if="usertype === USER_TYPE.FREE"
              href="#/Subscription"
            >
              <i class="material-icons" :title="$t('Upgrade')">verified</i>
              <p class="hidden-lg hidden-md">{{ $t("Upgrade") }}</p>
            </md-list-item>

            <md-list-item
              v-if="usertype === USER_TYPE.PRO || usertype === USER_TYPE.MAAC"
              href="#/Subscription"
            >
              <i class="material-icons" :title="$t('Upgrade')">verified</i>
              <p class="hidden-lg hidden-md">{{ $t("Upgrade") }}</p>
            </md-list-item>

            <md-list-item
              v-if="this.usertype !== USER_TYPE.AIRPORT"
              href="#/dashboard"
            >
              <i class="material-icons" :title="$t('Dashboard')">dashboard</i>
              <p class="hidden-lg hidden-md">{{ $t("Dashboard") }}</p>
            </md-list-item>
            <li
              class="md-list-item"
              v-if="
                usertype === USER_TYPE.ADMIN ||
                  usertype === USER_TYPE.ENTERPRISE ||
                  usertype === USER_TYPE.SUPER
              "
            >
              <a
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                    >
                      <md-icon>notifications</md-icon>
                      <span
                        v-if="
                          this.surveyNotificationCount +
                            this.droneNotificationCount +
                            this.pilotNotificationCount >
                            0
                        "
                        class="notification"
                        >{{
                          this.surveyNotificationCount +
                            this.droneNotificationCount +
                            this.pilotNotificationCount
                        }}</span
                      >
                      <p class="hidden-lg hidden-md">
                        {{ $t("Notifications") }}
                      </p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li>
                        <a
                          v-if="
                            this.surveyNotificationCount +
                              this.droneNotificationCount +
                              this.pilotNotificationCount ===
                              0
                          "
                          >{{ $t("No notifications") }}</a
                        >
                      </li>
                      <li>
                        <a href="#/sms" v-if="this.surveyNotificationCount > 0"
                          >{{ $t("You have") }}&nbsp;
                          <span class="text-danger">{{
                            surveyNotificationCount
                          }}</span
                          >&nbsp; {{ $t("sms notification")
                          }}<span v-if="surveyNotificationCount > 1">s</span></a
                        >
                      </li>
                      <li>
                        <a
                          href="#/settings/drone"
                          v-if="this.droneNotificationCount > 0"
                          >{{ $t("You have") }}&nbsp;
                          <span class="text-danger">{{
                            droneNotificationCount
                          }}</span
                          >&nbsp; {{ $t("drone notification")
                          }}<span v-if="droneNotificationCount > 1">s</span></a
                        >
                      </li>
                      <li>
                        <a
                          href="#/settings/pilot"
                          v-if="this.pilotNotificationCount > 0"
                          >{{ $t("You have") }}&nbsp;
                          <span class="text-danger">{{
                            pilotNotificationCount
                          }}</span
                          >&nbsp; {{ $t("pilot notification")
                          }}<span v-if="pilotNotificationCount > 1">s</span></a
                        >
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
            <md-list-item
              v-if="this.usertype !== USER_TYPE.AIRPORT"
              href="#/profile"
            >
              <i class="material-icons" :title="$t('Profile')">person</i>
              <p class="hidden-lg hidden-md">{{ $t("Profile") }}</p>
            </md-list-item>
            <md-list-item @click.stop="logOut">
              <i class="material-icons" :title="$t('Log Out')">exit_to_app</i>
              <p class="hidden-lg hidden-md">{{ $t("Log Out") }}</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { USER_TYPE } from "@/const.js";

export default {
  data() {
    return {
      language: window.localStorage.getItem("locale") === "fr" ? "EN" : "FR",
      USER_TYPE: USER_TYPE
    };
  },
  computed: {
    ...mapFields("survey", ["surveyNotificationCount"]),
    ...mapFields("stats", ["droneNotificationCount", "pilotNotificationCount"]),
    ...mapFields("auth", ["usertype"])
  },
  methods: {
    switchLanguage() {
      var locale = this.language.toLowerCase();
      window.localStorage.setItem("locale", locale);
      this.$root.$i18n.locale = locale;
      this.language = this.language === "FR" ? "EN" : "FR";
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    logOut() {
      this.$store.dispatch("auth/logout");
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>
<style lang="css">
.md-toolbar.md-transparent .md-title,
.md-toolbar.md-transparent .md-list .md-list-item-content,
.md-toolbar.md-transparent,
.md-toolbar.md-transparent:hover,
.md-toolbar.md-transparent:focus {
  color: black !important;
}
</style>
